import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { getOnboardingState } from '../../../store/selectors';
import InformationIcon from '../../utility/InformationIcon';
import { modalOpen_GTM } from '../../../gtm/datalayers/utilDataLayers.json';
import SunIcon from '../../utility/SunIcon.jsx';

// When a user clicks 'Edit Your Career Path' on a specific tab/card, it should automatically open the career list for that card
function EditCareerPathLink(props) {
  const career = props.onboarding.careerChoices[props.tabNumber];

  const { t } = useTranslation();
  const dispatch = useDispatch();

  const editCareerPathPrimary = {
    color: `${props.tenant.primary}`,
  };

  const handleEditPathClicked = (editPathClickedProps) => {
    dispatch({
      type: 'SET_CAREER_TAB',
      payload: {
        careerInfo: {
          ...editPathClickedProps.onboarding.degreeChoices,
        },
        careerTabSelected: true,
        currentTab: editPathClickedProps.tabNumber,
      },
    });
  };

  const handleInfoButtonSelected = () => {
    props.history.push(
      `${props.location.pathname}?career=${encodeURIComponent(
        props.career.titleEn
      )}`
    );
  };

  const mainContent = (
    <>
      <button
        className="edit-career-path-link"
        onClick={() => handleEditPathClicked(props)}
        onKeyDown={(e) => {
          if (['Enter'].includes(e.key)) handleEditPathClicked(props);
        }}
        type="button"
        tabIndex={0}
        style={editCareerPathPrimary}
        data-cy="edit-career-path-link"
        aria-label={t('Edit Your Career Path')}
      >
        {t('Edit Your Career Path')}
      </button>
      <div className="outlook-info-icon">
        {props.career.careerOutlook ? (
          <SunIcon setParentOnClick={props.setBrightOutlookModal} />
        ) : null}
        <button
          tabIndex="-1"
          type="button"
          aria-label={`Learn More About ${career.titleEn}`}
          onClick={() => {
            handleInfoButtonSelected();
          }}
          onKeyDown={(e) => {
            if (['Enter'].includes(e.key)) handleInfoButtonSelected();
          }}
          className="info-button"
          data-cy="info-button"
          id={`info-${career.titleEn}`}
        >
          <InformationIcon
            color={props.tenant.primary}
            gtmObj={modalOpen_GTM}
            section={career.titleEn}
            component="now let's build your career path"
            text="information"
            modalImage={props.modalImage}
          />
        </button>
      </div>
    </>
  );

  return mainContent;
}

function mapStateToProps(state) {
  const onboarding = getOnboardingState(state);

  return { onboarding };
}

export default withRouter(connect(mapStateToProps)(EditCareerPathLink));
